module.exports = __webpack_public_path__ + "static/img/zgyc.d95c60e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zgyc.png
// module id = XMVS
// module chunks = 0